/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_DescriptionInputs */

const en_gc_search_guides_gridcraft_online_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use GridCraft online without installing the desktop app. Launch a sample, open an XLSX file, edit cells, download your workbook and troubleshoot startup.`)
};

const zh_gc_search_guides_gridcraft_online_description = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无需安装桌面应用即可使用 GridCraft：启动示例、打开 XLSX、编辑单元格、下载工作簿，并排查启动问题。`)
};

/**
* | output |
* | --- |
* | "Use GridCraft online without installing the desktop app. Launch a sample, open an XLSX file, edit cells, download your workbook and troubleshoot startup." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_description = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_description(inputs)
	return zh_gc_search_guides_gridcraft_online_description(inputs)
});
export { gc_search_guides_gridcraft_online_description as "gc.search_guides.gridcraft_online.description" }